











































































































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import moment from 'moment'
import HashTip from '@/components/HashTip.vue'
import RawTx from '@/components/RawTx.vue'

@Component({
  components: {
    HashTip,
    RawTx,
  },
})
export default class Landing extends Vue {
  @namespace('bp').Getter latestHeight
  @namespace('bp').Getter landingBlocks
  @namespace('bp').Getter landingTxs

  public runningStatus = {}
  private interval

  mounted() {
    this.$store.dispatch('bp/connectBP').then(this.fetchData)
    this.interval = setInterval(this.fetchData, 3000)
  }

  // methods
  formatDate(date) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss')
  }

  fetchData() {
    this.$store.dispatch('bp/getBlocks', { page: 1, size: 10 })
    this.$store.dispatch('bp/getTxs', { page: 1, size: 10 })
  }

  destroyed() {
    clearInterval(this.interval)
  }
}
